var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:['badge', 'text-white', _vm.statuses[_vm.status].class],staticStyle:{"line-height":"1.2"}},[_vm._v(_vm._s(_vm.statuses[_vm.status].text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }